import { Injectable, Injector } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { throwError, Observable, BehaviorSubject } from 'rxjs';
import { take, filter, catchError, switchMap, finalize } from 'rxjs/operators';

import { AuthService } from 'src/app/_core/auth.service';
import { AppService } from 'src/app/app.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

    refreshTokenInProgress:boolean = false;
    // Refresh Token Subject tracks the current token, or is null if no token is currently available (e.g. refresh pending).
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
		public authService: AuthService,
		public appService: AppService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(req).pipe(
            catchError(err => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 400) {
                        return this.handle400Error(err);
                    } else if (err.status === 403) {
                        return this.handle403Error(err);
                    } else if (err.status === 401) {
						return this.handle401Error(req, next, err);
					} else {
						this.appService.logError(err);
                        return throwError(err);
                    }
				} else {
					this.appService.logError(err);
                    return err;
                }
            }));
    }

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + token }})
    }

    handle400Error(error) {
        /*
		if (error && error.status === 400 && error.error === 'invalid_grant') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.authService.signOut();
        }
		*/

        return throwError(error);
    }

	handle403Error(error) {
		/*
		 if (error && error.status === 403 && error.url.indexOf("/current") != -1) {
			//this.refreshTokenInProgress = false;
			this.authService.signOut();
        }
		*/
        return throwError(error);
    }

	handle401Error(req: HttpRequest<any>, next: HttpHandler, error?) {
		return throwError(error);
		/*
        if (!this.refreshTokenInProgress) {
            this.refreshTokenInProgress = true;

            // Reset the tokenSubject so that the following requests wait until the token comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return this.authService.refreshToken$()
                .pipe(
                    switchMap(response => {
                        if (response && response.access_token) {
                            console.log('Refresh Token Succeeded!');
                            this.authService.setHttpHeadersAccessToken(response.access_token, response.refresh_token);
                            this.refreshTokenInProgress = false;
                            this.tokenSubject.next(response.access_token);
                            return next.handle(this.addToken(req, response.access_token));
                        } else {
                            console.log('Refresh Token Failed!');
                            this.refreshTokenInProgress = false;
                            this.authService.signOut();
                            return throwError(response);
                        }
                    }),
                    catchError(error => {
                        console.log('Refresh Token Failed!');
                        this.refreshTokenInProgress = false;
                        this.authService.signOut();
                        return throwError(error);
                    })
            );
        } else {
            return this.tokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addToken(req, token));
                }));
        }
		*/
    }
}

import { IdempotencyInterceptor } from './idempotency.interceptor';

// Http interceptor providers in outside-in order
export const HttpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: IdempotencyInterceptor, multi: true }
];

